// removed by extract-text-webpack-plugin
module.exports = {"title":"_2c0P-xwhtS9l-OIFJm1Ayf","section":"_2tl5uPDdpS3AEiShj7BaM7","header":"_3GMCEMWyZ5EnLj1LS2Bk83","body":"Q6_Sz9I_Fvx5QRbPVWOLf","scrollSpy":"Y23U5mZ7TSuIJFyAP1vfc","scrollSpyCurrent":"_2zx2vCzqaRRKNUWLmUFZ33","scrollSpyItemCont":"OJWtxQksqxgXHwIk7lxnG","scrollSpyItem":"IVyyy7rGMGdiAgN0zXfQs","content":"_37AbpQzVPBiGTVuFRlqOox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/InfoPartition/infoPartition.scss
// module id = 1275
// module chunks = 1